import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Card } from "antd";
import { ReactNode, useCallback, useState } from "react";
import styles from "./CollapsibleTableCard.module.scss";

type Props = {
  title: string;
  count: number;
  children: ReactNode;
  defaultCollapsed?: boolean;
};

/**
 * Card used on the Dashboard tables (ÃvÃ©nements, Actions, Constats) only.
 * Displays the entries count in the title and can be expanded/collapsed,
 * collapsed by default.
 *
 * The content stays mounted (only hidden via CSS) while collapsed so that
 * the underlying table can still fetch its data and report an accurate count.
 */
const CollapsibleTableCard: React.FC<Props> = ({
  title,
  count,
  children,
  defaultCollapsed = true,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const toggle = useCallback(() => setIsCollapsed((prev) => !prev), []);

  return (
    <Card
      bordered={false}
      title={
        <div className={styles.header} onClick={toggle}>
          <span>
            {title} ({count})
          </span>
          {isCollapsed ? <DownOutlined /> : <UpOutlined />}
        </div>
      }
    >
      <div className={`${styles.content} ${isCollapsed ? styles.collapsed : ""}`}>
        {children}
      </div>
    </Card>
  );
};

export default CollapsibleTableCard;
